module.exports = __webpack_public_path__ + "static/media/emilyPhoto.a3679af5.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/images/emilyPhoto.JPG
// module id = 73
// module chunks = 0